'use client';
import {useState} from 'react';
import {useTranslations} from 'next-intl';

export default function ShareButton({ productLink }) {
  const t = useTranslations('catalog');
  
  const [copied, setCopied] = useState(false);
  
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(productLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error('Copy error', err);
    }
  };
  
  return (
      <li className="position-relative">
        <button
            type="button"
            title={t('share')}
            onClick={handleCopy}
            className="share-button"
        >
          <i className="fas fa-link"></i>
        </button>
        
        {copied && (
            <span
                className="position-absolute start-50 translate-middle-x bg-dark text-white text-nowrap small px-2 py-1 rounded"
                style={{ top: '-1.8rem' }}
            >
              {t('copied')}
            </span>
        )}
      </li>
  );
}
